import React, { lazy } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import history from './routerHistory'

import GlobalStyle from './style/Global'
import PageLoader from './components/PageLoader'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import 'bootstrap/dist/css/bootstrap.min.css';

const MainLayout = lazy(() => import('components/layout/MainLayout'))
const Home = lazy(() => import('./views/Home'))
const Faqs = lazy(() => import('./views/FaqsView'))

const App: React.FC = () => {
  return (
    <Router history={history}>
      <GlobalStyle />
      <SuspenseWithChunkError fallback={<PageLoader />}>
      {/* <PageLoader/> */}

        <Switch>
          <MainLayout>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/faqs" exact>
              <Faqs />
            </Route>
          </MainLayout>
        </Switch>
      </SuspenseWithChunkError>

    </Router>
  );
}

export default App;
